import styled from 'styled-components';

import { StyledFlexContainer } from 'src/components/core/layout/FlexContainer';

export const PairInfoContainer = styled(StyledFlexContainer)`
    & span {
        min-width: 100%;
    }
    &:nth-child(1) {
        overflow-x: hidden;
    }
`;

export const PairName = styled(StyledFlexContainer)`
    ${({ theme: { colors, typography } }) => `
        color: ${colors.text.tertiary};
        & > div {
            &:nth-of-type(1) {
                min-width: max-content;
                display: flex;
                flex-direction: column;
                & > span {
                    &:nth-child(1) {
                        line-height: ${typography.lineHeight[4]};
                    }
                    & > :nth-child(1) {
                        color: ${colors.text.primary};
                    }
                    &:nth-child(2) {
                        font-size: ${typography.size.desktop.paragraph.p3};
                    }
                }
            }
            &:nth-of-type(2) {
                font-size: ${typography.size.desktop.paragraph.p3};
                line-height: ${typography.lineHeight[2]};
                font-weight: ${typography.weight.medium};
                border: 1px solid ${colors.primary};
                overflow: hidden;
                border-radius: 2px;
                display: flex;
                align-items: center;
                margin-left: 4px;
                padding: 0 2px;
                text-align: center;
            }
        }
        & > svg {
            margin-left: 4px;
        }
    `}
`;

export const Bar = styled.div<{ height: string; margin: string }>`
    ${({ theme: { colors }, height, margin }) => `
        border: 1px solid ${colors.border.light};
        height: ${height};
        margin: ${margin};
    `}
`;

export const PairInfoModuleWrapper = styled(StyledFlexContainer)`
    ${({ theme: { breakpoints } }) => `
        @media (max-width: ${breakpoints.lg}) {
            overflow-x: scroll;
            margin-right: 24px;
            -ms-overflow-style: none;
            scrollbar-width: none;
            &::-webkit-scrollbar {
                display: none;
            }
        }
    `}
`;

export const ThemeSwitchWrapper = styled(StyledFlexContainer)`
    ${({ theme: { breakpoints } }) => `
        @media (max-width: ${breakpoints.lg}) {
            padding-right: 24px;
        }
    `}
`;

export const PairInfoModule = styled(StyledFlexContainer)`
    flex-direction: column;
    min-width: max-content;
    ${({ theme: { colors, typography } }) => `
        &.heading {
            font-size: ${typography.size.desktop.heading.h6};
            line-height: calc(${typography.lineHeight[7]} - 1px);
            font-weight: ${typography.weight.medium};
            letter-spacing: -0.03em;
        }
        & > span {
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            &:nth-of-type(1) {
                color: ${colors.text.tertiary};
                margin-bottom: 4px;
                &.funding-rate {
                    & span {
                        cursor: pointer;
                    }
                }
            }
            &:nth-of-type(2) {
                color: ${colors.text.primary};
            }
        }
        &:not(:last-of-type) {
            margin-right: 24px;
        }
    `}
`;
